module.exports = __webpack_public_path__ + "media/images/guy_floating-p-500-8fdb1b45cb51b171d05b023047339a63.png";